// 确认弹窗上下文组件
"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, type ReactNode, useCallback, useContext, useState } from "react";
import { ConfirmModal } from "./confirm-modal";
interface ConfirmOptions {
  title?: ReactNode;
  description?: ReactNode;
  confirmText?: ReactNode;
  cancelText?: ReactNode;
  content?: ReactNode;
  onConfirmAction?: () => Promise<void> | void;
  hideCancelButton?: boolean;
  /** 出错时是否关闭弹窗，默认false */
  closeOnError?: boolean;
}
type ConfirmFn = (options: ConfirmOptions) => Promise<boolean>;
const ConfirmContext = createContext<ConfirmFn | null>(null);
export function ConfirmProvider(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  const [modal, setModal] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = options => new Promise(resolvePromise => {
      let resolved = false;
      const resolve = value => {
        if (!resolved) {
          resolved = true;
          resolvePromise(value);
        }
      };
      const closeModalAndResolve = value_0 => {
        setModal(null);
        resolve(value_0);
      };
      const handleModalConfirm = async () => {
        if (options.onConfirmAction) {
          ;
          try {
            await options.onConfirmAction();
            closeModalAndResolve(true);
          } catch (t2) {
            const error = t2;
            console.error("Confirmation action failed:", error);
            if (options.closeOnError) {
              closeModalAndResolve(false);
            } else {
              resolve(false);
            }
            throw error;
          }
        } else {
          closeModalAndResolve(true);
        }
      };
      setModal(<ConfirmModal open={true} title={options.title} description={options.description} confirmText={options.confirmText} cancelText={options.cancelText} hideCancelButton={options.hideCancelButton} closeOnError={options.closeOnError} onOpenChange={open => {
        if (!open) {
          closeModalAndResolve(false);
        }
      }} onConfirm={handleModalConfirm} onCancel={() => {
        closeModalAndResolve(false);
      }}>{options.content}</ConfirmModal>);
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const confirm = t1;
  let t2;
  if ($[1] !== children || $[2] !== modal) {
    t2 = <ConfirmContext.Provider value={confirm}>{children}{modal}</ConfirmContext.Provider>;
    $[1] = children;
    $[2] = modal;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
export function useConfirm() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) {
    throw new Error("useConfirm \u5FC5\u987B\u5728 ConfirmProvider \u5185\u4F7F\u7528");
  }
  return ctx;
}